import { BridgeClient } from 'app/service/bridge/BridgeClient';

/**
 * Creates a product-selector API backed by the bridge transport.
 *
 * Bridge actions used:
 *   product_selector.search   → BridgeUseCase → ProductSelectorSearchInterface
 *   product_selector.resolve  → BridgeUseCase → ProductSelectorRepositoryInterface
 */
export function createBridgeProductSelectorApi() {
  const client = new BridgeClient();

  return {
    /**
     * Full-text product search.  Numeric queries (#123 / 123) are resolved by
     * product ID on the backend before a full-text fallback is attempted.
     *
     * @param {string} query
     * @param {number} [limit=8]
     * @returns {Promise<Array>} canonical product cards
     */
    async searchProducts(query, limit = 8) {
      const response = await client.sendMessageWithResponse('product_selector.search', {
        query,
        limit,
      });
      return (response.items || []).map((item) => ({ ...item, id: String(item.id) }));
    },

    /**
     * Resolve saved product IDs to canonical product cards.
     *
     * @param {string[]} ids  Opaque product identifiers
     * @returns {Promise<{ items: Array, unresolved_ids: string[] }>}
     */
    async resolveProducts(ids) {
      const safeIds = (ids || []).map(String);
      const response = await client.sendMessageWithResponse('product_selector.resolve', { ids: safeIds });
      return {
        items: (response.items || []).map((item) => ({ ...item, id: String(item.id) })),
        unresolved_ids: (response.unresolved_ids || []).map(String),
      };
    },
  };
}
